import { render, staticRenderFns } from "./badges_history.vue?vue&type=template&id=f6f5822a&scoped=true&"
import script from "./badges_history.vue?vue&type=script&lang=js&"
export * from "./badges_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f5822a",
  null
  
)

export default component.exports